<form [formGroup]="form()">
  <div class="" hlmFieldGroup>
    <fieldset hlmFieldSet>
      <legend class="!mb-lg" hlmFieldLegend>2. Aptitudes</legend>

      <app-aptitude-group [form]="formService().aptitudePrincipale" index="principale" />
      @for (aptitudeForm of formService().aptitudesSecondaires.controls; track $index; let idx = $index) {
        <app-aptitude-group
          [index]="idx"
          [form]="aptitudeForm"
          (supprimerAptitude)="formService().supprimerAptitude(idx)"
          peutSupprimer
        />
      }

      @if (formService().aptitudePrincipale.value.aptitude) {
        <button (click)="formService().ajouterAptitudeSecondaire()" hlmBtn variant="zone" size="large">
          <ng-icon name="lucidePlus" />
          <span class="text-components-content-neutral-secondary component-small-medium">Ajouter une aptitude</span>
        </button>
      }
    </fieldset>
  </div>
</form>
